import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { getData, patchData, postData } from "src/utils/axios/serverHelper";
import { HRM2040_R01Dto } from "./Dto_HRM2040_R01";
import { HRM2040_R01Filter } from "./Store_HRM2040_R01";

/** HRM2040_R01 백엔드의 공통 경로이다. */
const BASE_URL = `${config.apiUrl}/HRM2040_R01`;

/**
 * 저장된 월근태 행을 조회한다.
 * @param option 일반 조회 search 또는 저장·재집계 후 재조회 refetch
 * @param params 근무년월·사업장·부서 조건
 * @param listLength 백엔드 경로 규칙에 맞춰 전달하는 목록 길이
 * @returns 월근태 행 목록을 담은 서버 응답
 */
export const getHRM2040_R01List = async (
    option: 'search' | 'refetch', params: Partial<HRM2040_R01Filter>, listLength = 0,
) => getData<ResponseDto<HRM2040_R01Dto[]>>(
    `${BASE_URL}/${option}`, { params: { ...params, listLength } },
);

/**
 * 변경된 월근태 행만 저장한다.
 * @param data 변경된 기존 행 목록
 * @returns 저장 건수를 담은 서버 응답
 */
export const patchHRM2040_R01 = async (data: HRM2040_R01Dto[]) =>
    patchData<HRM2040_R01Dto[], ResponseDto<number>>(BASE_URL, data);

/**
 * 직전 조회조건의 재직 사원을 서버에서 월별로 재집계한다.
 * @param data 조회에 사용한 근무년월·사업장·부서
 * @returns 집계한 사원 수를 담은 서버 응답
 */
export const postHRM2040_R01Aggregate = async (data: HRM2040_R01Filter) =>
    postData<HRM2040_R01Filter, ResponseDto<number>>(`${BASE_URL}/aggregate`, data);

/**
 * 조회와 같은 조건의 서버 XLSX를 받는다.
 * @param option Excel 검색 경로 search
 * @param params 근무년월·사업장·부서 조건
 * @param listLength 백엔드 경로 규칙에 맞춰 전달하는 목록 길이
 * @returns 인코딩된 XLSX를 담은 서버 응답
 */
export const downloadExcel_HRM2040_R01 = async (
    option: 'search', params: Partial<HRM2040_R01Filter>, listLength = 0,
) => getData<ResponseDto<string>>(
    `${BASE_URL}/excel/${option}`, { params: { ...params, listLength } },
);
